import styled from "styled-components"

export const StyledTextWrapper = styled.div``

export const StyledText = styled.div`
  ${(props) => props.theme.mixins.markdown};
  p {
    color: ${(props) => props.theme.colors.darkGrey};
  }
`
